export default __webpack_public_path__ + "static/media/ai-cloudscape.9e12e9c6.png";